export const routes = [
  ...require('./invoice/routes').routes,
  ...require('./legal-settlements/routes').routes
]
